var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-lines */
import React, { Component } from 'react';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import PropTypes from 'prop-types';

import { Icon } from "../../UI";
import { withContext, withRouter } from "../../componentWrappers";
import { MetadataFormButtons, ShowMetadata } from "../../Metadata";
import { NeedAuthorization } from "../../Auth";
import { I18NLink, t, Translate } from "../../I18N";
import { AttachmentsList } from "../../Attachments";
import { FileList } from "../../Attachments/components/FileList";
import Connections from "../../Viewer/components/ConnectionsList";
import { ConnectionsGroups } from "../../ConnectionsList";
import ShowIf from "../../App/ShowIf";
import SidePanel from "../../Layout/SidePanel";
import DocumentSemanticSearchResults from "../../SemanticSearch/components/DocumentResults";
import { CopyFromEntity } from "../../Metadata/components/CopyFromEntity";
import { TocGeneratedLabel, ReviewTocButton } from "../../ToggledFeatures/tocGeneration";
import { actions } from "../../BasicReducer";
import { Item } from "../../Layout";
import * as viewerModule from "../../Viewer";
import * as viewerActions from "../../Viewer/actions/actionTypes";
import { entityDefaultDocument } from "../../../shared/entityDefaultDocument";
import ViewDocButton from "../../Library/components/ViewDocButton";
import { getDocumentReferences } from "../../Library/actions/libraryActions";
import { store } from "../../store";
import SearchText from "./SearchText";
import ShowToc from "./ShowToc";
import SnippetsTab from "./SnippetsTab";
import helpers from "../helpers";
import "./scss/toc.scss";

class DocumentSidePanel extends Component {
  constructor(props) {
    super(props);
    this.selectTab = this.selectTab.bind(this);
    this.state = { copyFrom: false, copyFromProps: [], relationshipsExpanded: true };
    this.toggleCopyFrom = this.toggleCopyFrom.bind(this);
    this.onCopyFromSelect = this.onCopyFromSelect.bind(this);
    this.updateRelationships = this.updateRelationships.bind(this);
    this.deleteDocument = this.deleteDocument.bind(this);
    this.toggleSharing = this.toggleSharing.bind(this);
  }

  componentDidMount() {
    if (this.props.selectedDocument) {
      this.updateRelationships(this.props.selectedDocument.get('sharedId'));
    }
  }

  async componentDidUpdate(prevProps) {
    const sharedId = this.props.doc.get('sharedId');
    if (this.props.doc.get('_id') && prevProps.doc.get('_id') !== this.props.doc.get('_id')) {
      this.updateRelationships(sharedId);
    }
  }

  onCopyFromSelect(copyFromProps) {
    this.setState({ copyFromProps });
  }

  getDefaultDocumentToC(isEntity, documents, language, defaultLanguage) {
    let defaultDocumentToC = this.props.file.toc;

    if (!isEntity) {
      const defaultDocument = _objectSpread({},
      entityDefaultDocument(documents, language, defaultLanguage));

      if (defaultDocument) {
        defaultDocumentToC = defaultDocument.toc;
      }
    }
    return defaultDocumentToC;
  }

  async updateRelationships(sharedId) {
    if (sharedId && this.props.connectionsChanged && getDocumentReferences) {
      this.props.getDocumentReferences(sharedId, this.props.file._id, this.props.storeKey);
      this.props.connectionsChanged(sharedId);
    }
  }

  deleteDocument() {
    this.props.mainContext.confirm({
      accept: () => {
        this.props.deleteDocument(this.props.doc.toJS()).then(() => {
          const currentPath = this.props.location.pathname;
          const isLibrary = /library|^\/$|^\/..\/$/;
          if (!currentPath.match(isLibrary)) {
            this.props.navigate(-1);
          }
        });
      },
      title: 'Confirm',
      message: 'Are you sure you want to delete this item?'
    });
  }

  selectTab(tabSelected) {
    this.props.showTab(tabSelected);
  }

  _close() {
    this.props.resetForm(this.props.formPath);
    this.props.closePanel();
    this.setState({ copyFrom: false });
  }

  close() {
    if (this.props.formDirty) {
      this.props.mainContext.confirm({
        accept: () => {
          this._close();
        },
        title: 'Confirm',
        message: 'All changes will be lost, are you sure you want to proceed?'
      });
      return;
    }
    this._close();
  }

  toggleCopyFrom() {
    this.setState((currentState) => ({
      copyFrom: !currentState.copyFrom
    }));
  }

  toggleSharing() {
    this.setState((currentState) => ({
      sharing: !currentState.sharing
    }));
  }

  collapseRelationships() {
    // Toggles the states to force re-rendering
    this.setState({ relationshipsExpanded: true }, () =>
    this.setState({ relationshipsExpanded: false })
    );
  }

  expandRelationships() {
    // Toggles the states to force re-rendering
    this.setState({ relationshipsExpanded: false }, () =>
    this.setState({ relationshipsExpanded: true })
    );
  }

  // eslint-disable-next-line class-methods-use-this
  linkClassNames(selectedTabMatches) {
    return `${selectedTabMatches ? 'selected' : ''} entity-sidepanel-tab-link`;
  }

  renderHeader(tab, doc, isEntity) {
    if (this.state.copyFrom) {
      return (/*#__PURE__*/
        _jsx("div", { className: "sidepanel-header" }, void 0, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Copy properties to this entity from"), ":"
        ));

    }

    const {
      excludeConnectionsTab,
      connectionsGroups,
      isTargetDoc,
      references,
      currentSidepanelView,
      location
    } = this.props;

    const summary = connectionsGroups.reduce(
      (summaryData, group) => {
        const summarizedData = _objectSpread({}, summaryData);
        group.get('templates').forEach((template) => {
          summarizedData.totalConnections += template.get('count');
        });
        return summarizedData;
      },
      { totalConnections: 0 }
    );

    const linkTo = (entityTab) =>
    `/entity/${doc.get('sharedId')}/${entityTab}${(location === null || location === void 0 ? void 0 : location.search) || ''}`;

    return (/*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("div", { className: "sidepanel-header" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "closeSidepanel close-modal",
        onClick: this.close.bind(this),
        "aria-label": "Close side panel" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "times" })
      ), /*#__PURE__*/
      _jsx(Tabs, { selectedTab: tab, renderActiveTabContentOnly: true, handleSelect: this.selectTab }, void 0, /*#__PURE__*/
      _jsx("ul", { className: "nav nav-tabs" }, void 0,
      (() => {
        if (!this.props.raw && doc.get('semanticSearch')) {
          return (/*#__PURE__*/
            _jsx("li", {}, void 0, /*#__PURE__*/
            _jsx(ShowIf, { if: currentSidepanelView === 'entity' }, void 0, /*#__PURE__*/
            _jsx(TabLink, {
              className: "",
              to: "semantic-search-results",
              role: "button",
              tabIndex: "0",
              "aria-label": t('System', 'Semantic search results', null, false),
              component: "div" }, void 0, /*#__PURE__*/

            _jsx(I18NLink, {
              className: this.linkClassNames(tab === 'semantic-search-results'),
              to: linkTo('semantic-search-results'),
              onClick: () =>
              store.dispatch(
                actions.set('viewer.sidepanel.tab', 'semantic-search-results')
              ) }, void 0, /*#__PURE__*/


            _jsx(Icon, { icon: "flask" }), /*#__PURE__*/
            _jsx("span", { className: "tab-link-tooltip" }, void 0, /*#__PURE__*/
            _jsx(Translate, {}, void 0, "Semantic search results")
            )
            )
            )
            ), /*#__PURE__*/
            _jsx(ShowIf, { if: currentSidepanelView === 'library' }, void 0, /*#__PURE__*/
            _jsx(TabLink, {
              to: "semantic-search-results",
              role: "button",
              tabIndex: "0",
              "aria-label": t('System', 'Semantic search results', null, false),
              component: "div" }, void 0, /*#__PURE__*/

            _jsx(Icon, { icon: "flask" }), /*#__PURE__*/
            _jsx("span", { className: "tab-link-tooltip" }, void 0, /*#__PURE__*/
            _jsx(Translate, {}, void 0, "Semantic search results")
            )
            )
            )
            ));

        }
      })(),
      (() => {
        if (!this.props.raw) {
          return (/*#__PURE__*/
            _jsx("li", {}, void 0, /*#__PURE__*/
            _jsx(ShowIf, { if: currentSidepanelView === 'entity' }, void 0, /*#__PURE__*/
            _jsx(TabLink, {
              to: "text-search",
              role: "button",
              tabIndex: "0",
              "aria-label": t('System', 'Search text', null, false),
              component: "div" }, void 0, /*#__PURE__*/

            _jsx(I18NLink, {
              className: this.linkClassNames(tab === 'text-search'),
              to: linkTo('text-search'),
              onClick: () =>
              store.dispatch(actions.set('viewer.sidepanel.tab', 'text-search')) }, void 0, /*#__PURE__*/


            _jsx(SnippetsTab, { storeKey: this.props.storeKey })
            )
            )
            ), /*#__PURE__*/
            _jsx(ShowIf, { if: currentSidepanelView === 'library' }, void 0, /*#__PURE__*/
            _jsx(TabLink, {
              to: "text-search",
              role: "button",
              tabIndex: "0",
              "aria-label": t('System', 'Search text', null, false),
              component: "div" }, void 0, /*#__PURE__*/

            _jsx(SnippetsTab, { storeKey: this.props.storeKey })
            )
            )
            ));

        }
      })(),
      (() => {
        if (!isEntity && !this.props.raw) {
          return (/*#__PURE__*/
            _jsx("li", {}, void 0, /*#__PURE__*/
            _jsx(ShowIf, { if: currentSidepanelView === 'entity' }, void 0, /*#__PURE__*/
            _jsx(TabLink, {
              to: "toc",
              role: "button",
              tabIndex: "0",
              "aria-label": t('System', 'Table of Contents', null, false),
              component: "div" }, void 0, /*#__PURE__*/

            _jsx(I18NLink, {
              className: this.linkClassNames(tab === 'toc'),
              to: linkTo('toc'),
              onClick: () =>
              store.dispatch(actions.set('viewer.sidepanel.tab', 'toc')) }, void 0, /*#__PURE__*/


            _jsx(Icon, { icon: "font" }), /*#__PURE__*/
            _jsx("span", { className: "tab-link-tooltip" }, void 0,
            t('System', 'Table of Contents')
            )
            )
            )
            ), /*#__PURE__*/
            _jsx(ShowIf, { if: currentSidepanelView === 'library' }, void 0, /*#__PURE__*/
            _jsx(TabLink, {
              to: "toc",
              role: "button",
              tabIndex: "0",
              "aria-label": t('System', 'Table of Contents', null, false),
              component: "div" }, void 0, /*#__PURE__*/

            _jsx(Icon, { icon: "font" }), /*#__PURE__*/
            _jsx("span", { className: "tab-link-tooltip" }, void 0,
            t('System', 'Table of Contents')
            )
            )
            )
            ));

        }
        return /*#__PURE__*/_jsx("span", {});
      })(),
      (() => {
        if (!isEntity && !this.props.raw) {
          return (/*#__PURE__*/
            _jsx("li", {}, void 0, /*#__PURE__*/
            _jsx(ShowIf, { if: currentSidepanelView === 'entity' }, void 0, /*#__PURE__*/
            _jsx(TabLink, {
              to: "references",
              role: "button",
              tabIndex: "0",
              "aria-label": t('System', 'References', null, false),
              component: "div" }, void 0, /*#__PURE__*/

            _jsx(I18NLink, {
              className: this.linkClassNames(tab === 'references'),
              to: linkTo('references'),
              onClick: () =>
              store.dispatch(actions.set('viewer.sidepanel.tab', 'references')),

              replacenavigationhistory: "true" }, void 0, /*#__PURE__*/

            _jsx(Icon, { icon: "sitemap" }), /*#__PURE__*/
            _jsx("span", { className: "connectionsNumber" }, void 0, references.size), /*#__PURE__*/
            _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'References'))
            )
            )
            ), /*#__PURE__*/
            _jsx(ShowIf, { if: currentSidepanelView === 'library' }, void 0, /*#__PURE__*/
            _jsx(TabLink, {
              to: "references",
              role: "button",
              tabIndex: "0",
              "aria-label": t('System', 'References', null, false),
              component: "div" }, void 0, /*#__PURE__*/

            _jsx(Icon, { icon: "sitemap" }), /*#__PURE__*/
            _jsx("span", { className: "connectionsNumber" }, void 0, references.size), /*#__PURE__*/
            _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'References'))
            )
            )
            ));

        }
        return /*#__PURE__*/_jsx("span", {});
      })(),
      (() => {
        if (!this.props.raw) {
          return /*#__PURE__*/_jsx("li", { className: "tab-separator" });
        }
        return /*#__PURE__*/_jsx("span", {});
      })(), /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx(ShowIf, { if: currentSidepanelView === 'entity' }, void 0, /*#__PURE__*/
      _jsx(TabLink, {
        to: "metadata",
        default: true,
        role: "button",
        tabIndex: "0",
        "aria-label": t('System', 'Info', null, false),
        component: "div" }, void 0, /*#__PURE__*/

      _jsx(I18NLink, {
        className: this.linkClassNames(tab === 'metadata' || tab === ''),
        to: linkTo('metadata'),
        onClick: () =>
        store.dispatch(actions.set('viewer.sidepanel.tab', 'metadata')) }, void 0, /*#__PURE__*/


      _jsx(Icon, { icon: "info-circle" }), /*#__PURE__*/
      _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'Info'))
      )
      )
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: currentSidepanelView === 'library' }, void 0, /*#__PURE__*/
      _jsx(TabLink, {
        to: "metadata",
        default: true,
        role: "button",
        tabIndex: "0",
        "aria-label": t('System', 'Info', null, false),
        component: "div" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "info-circle" }), /*#__PURE__*/
      _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'Info'))
      )
      )
      ),
      (() => {
        if (!isTargetDoc && !excludeConnectionsTab) {
          return (/*#__PURE__*/
            _jsx("li", {}, void 0, /*#__PURE__*/
            _jsx(ShowIf, { if: currentSidepanelView === 'entity' }, void 0, /*#__PURE__*/
            _jsx(TabLink, {
              to: "relationships",
              role: "button",
              tabIndex: "0",
              "aria-label": t('System', 'Relationships', null, false),
              component: "div" }, void 0, /*#__PURE__*/

            _jsx(I18NLink, {
              className: this.linkClassNames(tab === 'relationships'),
              to: linkTo('relationships'),
              onClick: () => {
                store.dispatch(actions.set('viewer.sidepanel.tab', 'relationships'));
                store.dispatch({ type: viewerActions.UNSET_SELECTION });
              } }, void 0, /*#__PURE__*/

            _jsx(Icon, { icon: "exchange-alt" }), /*#__PURE__*/
            _jsx("span", { className: "connectionsNumber" }, void 0, summary.totalConnections), /*#__PURE__*/
            _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'Relationships'))
            )
            )
            ), /*#__PURE__*/
            _jsx(ShowIf, { if: currentSidepanelView === 'library' }, void 0, /*#__PURE__*/
            _jsx(TabLink, {
              to: "relationships",
              role: "button",
              tabIndex: "0",
              "aria-label": t('System', 'Relationships', null, false),
              component: "div" }, void 0, /*#__PURE__*/

            _jsx(Icon, { icon: "exchange-alt" }), /*#__PURE__*/
            _jsx("span", { className: "connectionsNumber" }, void 0, summary.totalConnections), /*#__PURE__*/
            _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'Relationships'))
            )
            )
            ));

        }
      })(), /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx(ShowIf, {
        if: this.props.newRelationshipsEnabled && currentSidepanelView === 'entity' }, void 0, /*#__PURE__*/

      _jsx(TabLink, {
        to: "newrelationships",
        role: "button",
        tabIndex: "0",
        "aria-label": "New Relationships",
        component: "div" }, void 0, /*#__PURE__*/

      _jsx(I18NLink, {
        className: this.linkClassNames(['newrelationships']),
        to: linkTo('newrelationships'),
        onClick: () =>
        store.dispatch(actions.set('viewer.sidepanel.tab', 'newrelationships')) }, void 0, /*#__PURE__*/


      _jsx(Icon, { icon: "exchange-alt" }), "*", /*#__PURE__*/
      _jsx("span", { className: "tab-link-tooltip", "no-translate": true }, void 0, "New Relationships"

      )
      )
      )
      )
      )
      )
      )
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: this.props.tab === 'relationships' }, void 0, /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Item, { active: false, doc: this.props.doc, className: "item-collapsed", noMetadata: true })
      )
      )
      ));

  }

  render() {
    const {
      doc,
      docBeingEdited,
      readOnly,
      references,
      EntityForm,
      isTargetDoc,
      relationships,
      defaultLanguage,
      currentSidepanelView
    } = this.props;

    const TocForm = this.props.tocFormComponent;

    const jsDoc = helpers.performantDocToJSWithoutRelations(doc);
    const { attachments, documents, language, defaultDoc } = jsDoc;

    const isEntity = !documents || !documents.length;

    const defaultDocumentToC =
    isEntity || !defaultDoc ?
    this.getDefaultDocumentToC(isEntity, documents, language, defaultLanguage) :
    defaultDoc.toc;

    this.initialTemplateId = doc.get('template');
    const tab =
    isEntity && (this.props.tab === 'references' || this.props.tab === 'toc') || !this.props.tab ?
    'metadata' :
    this.props.tab;

    const className =
    this.state.copyFrom && docBeingEdited && tab === 'metadata' ?
    'metadata-sidepanel two-columns' :
    'metadata-sidepanel';

    return (/*#__PURE__*/
      _jsx(SidePanel, { "data-testid": "metadata-sidepanel", open: this.props.open, className: className }, void 0,
      this.renderHeader(tab, doc, isEntity), /*#__PURE__*/
      _jsx(ShowIf, { if: (this.props.tab === 'metadata' || !this.props.tab) && !this.state.copyFrom }, void 0, /*#__PURE__*/
      _jsx("div", { className: "sidepanel-footer" }, void 0, /*#__PURE__*/
      _jsx(MetadataFormButtons, {
        delete: this.deleteDocument,
        data: this.props.doc,
        formStatePath: this.props.formPath,
        formState: this.props.formState,
        entityBeingEdited: docBeingEdited,
        includeViewButton: !docBeingEdited && readOnly,
        storeKey: this.props.storeKey,
        copyFrom: this.toggleCopyFrom }
      )
      )
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: this.props.tab === 'relationships' && currentSidepanelView === 'library' }, void 0, /*#__PURE__*/
      _jsx("div", { className: "sidepanel-footer" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "relationships-left-buttons" }, void 0, /*#__PURE__*/
      _jsx(ViewDocButton, { icon: "file", sharedId: doc.get('sharedId') })
      ), /*#__PURE__*/
      _jsx("div", { className: "relationships-right-buttons" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-default relationships-collapse-button",
        style: { marginRight: '10px' },
        onClick: () => this.collapseRelationships() }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Collapse all")
      ), /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-default relationships-expand-button",
        onClick: () => this.expandRelationships() }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Expand all")
      )
      )
      )
      ), /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [jsDoc] }, void 0,
      this.props.tab === 'toc' && this.props.tocBeingEdited && /*#__PURE__*/
      _jsx("div", { className: "sidepanel-footer" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "btn-cluster content-right" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "edit-toc btn btn-default",
        onClick: this.props.leaveEditMode }, void 0, /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Cancel")
      )
      ), /*#__PURE__*/
      _jsx("button", { type: "submit", form: "tocForm", className: "edit-toc btn btn-success" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Save")
      )
      )
      )
      )

      ), /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [jsDoc] }, void 0,
      this.props.tab === 'toc' && !this.props.tocBeingEdited && !readOnly && /*#__PURE__*/
      _jsx("div", { className: "sidepanel-footer" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "btn-cluster" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: () => this.props.editToc(this.props.file.toc || []),
        className: "edit-toc btn btn-default" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "pencil-alt" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Edit")
      )
      ), /*#__PURE__*/
      _jsx(ReviewTocButton, { file: this.props.file }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Mark as Reviewed")
      )
      )
      )

      ), /*#__PURE__*/
      _jsx("div", { className: "sidepanel-body scrollable" }, void 0, /*#__PURE__*/
      _jsx(Tabs, { selectedTab: this.props.tab || 'metadata' }, void 0, /*#__PURE__*/
      _jsx(TabContent, { for: "text-search", className: "text-search" }, void 0, /*#__PURE__*/
      _jsx(SearchText, {
        doc: doc,
        storeKey: this.props.storeKey,
        searchTerm: this.props.searchTerm }
      )
      ), /*#__PURE__*/
      _jsx(TabContent, { for: "toc", className: "toc" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "tocHeader" }, void 0, /*#__PURE__*/
      _jsx("h1", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Table of contents")
      ), "\xA0", /*#__PURE__*/

      _jsx(TocGeneratedLabel, { file: this.props.file }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "auto-created"), " \u24D8"
      )
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: !this.props.tocBeingEdited }, void 0, /*#__PURE__*/
      _jsx(ShowToc, { toc: defaultDocumentToC, readOnly: readOnly })
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: this.props.tocBeingEdited }, void 0, /*#__PURE__*/
      _jsx(TocForm, {
        removeEntry: this.props.removeFromToc,
        indent: this.props.indentTocElement,
        onSubmit: this.props.saveToc,
        model: "documentViewer.tocForm",
        state: this.props.tocFormState,
        toc: this.props.tocForm,
        file: this.props.file }
      )
      )
      ), /*#__PURE__*/
      _jsx(TabContent, { for: "metadata", className: "metadata" }, void 0,
      (() => {
        if (docBeingEdited && this.state.copyFrom) {
          return (/*#__PURE__*/
            _jsx("div", { className: "side-panel-container" }, void 0, /*#__PURE__*/
            _jsx(EntityForm, {
              storeKey: this.props.storeKey,
              initialTemplateId: this.initialTemplateId,
              highlightedProps: this.state.copyFromProps }
            ), /*#__PURE__*/
            _jsx(CopyFromEntity, {
              isVisible: this.state.copyFrom,
              originalEntity: this.props.formData,
              templates: this.props.templates,
              onSelect: this.onCopyFromSelect,
              formModel: this.props.formPath,
              onCancel: this.toggleCopyFrom }
            )
            ));

        }
        if (docBeingEdited) {
          return (/*#__PURE__*/
            _jsx(EntityForm, {
              storeKey: this.props.storeKey,
              initialTemplateId: this.initialTemplateId }
            ));

        }
        return (/*#__PURE__*/
          _jsx("div", {}, void 0, /*#__PURE__*/
          _jsx(ShowMetadata, {
            relationships: relationships,
            entity: jsDoc,
            showTitle: true,
            showType: true,
            groupGeolocations: true }
          ), /*#__PURE__*/
          _jsx(FileList, { files: documents, storeKey: this.props.storeKey, entity: jsDoc }), /*#__PURE__*/
          _jsx(AttachmentsList, {
            attachments: attachments,
            isTargetDoc: isTargetDoc,
            isDocumentAttachments: Boolean(doc.get('file')),
            parentId: doc.get('_id'),
            parentSharedId: doc.get('sharedId'),
            storeKey: this.props.storeKey,
            entity: jsDoc }
          )
          ));

      })()
      ), /*#__PURE__*/
      _jsx(TabContent, { for: "references", className: "references" }, void 0, /*#__PURE__*/
      _jsx(Connections, {
        referencesSection: "references",
        references: references,
        readOnly: readOnly }
      )
      ), /*#__PURE__*/
      _jsx(TabContent, { for: "relationships", className: "connections" }, void 0, /*#__PURE__*/
      _jsx(ConnectionsGroups, { expanded: this.state.relationshipsExpanded })
      ), /*#__PURE__*/
      _jsx(TabContent, { for: "semantic-search-results" }, void 0, /*#__PURE__*/
      _jsx(DocumentSemanticSearchResults, { doc: jsDoc })
      )
      )
      )
      ));

  }
}

DocumentSidePanel.defaultProps = {
  tab: 'metadata',
  open: false,
  tocBeingEdited: false,
  docBeingEdited: false,
  searchTerm: '',
  references: Immutable.fromJS([]),
  relationships: Immutable.fromJS([]),
  tocFormState: {},
  formDirty: false,
  isTargetDoc: false,
  readOnly: false,
  getDocumentReferences: undefined,
  connectionsChanged: undefined,
  tocFormComponent: () => false,
  EntityForm: () => false,
  raw: false,
  file: {},
  leaveEditMode: () => {},
  selectedDocument: undefined,
  // relationships v2
  newRelationshipsEnabled: false
};






















































const mapStateToProps = (state, ownProps) => {var _state$settings, _state$settings$colle, _state$settings$colle2;
  const isTargetDoc = state.documentViewer.targetDoc.get('_id');
  const relevantReferences = isTargetDoc ?
  viewerModule.selectors.selectTargetReferences(state) :
  viewerModule.selectors.selectReferences(state);
  const references = ownProps.references ?
  viewerModule.selectors.parseReferences(ownProps.doc, ownProps.references) :
  relevantReferences;
  const defaultLanguage = state.settings.collection.
  get('languages').
  find((l) => l.get('default')).
  get('key');

  const selectedDocument =
  state.library.ui.get('selectedDocuments').size === 1 ?
  state.library.ui.get('selectedDocuments').get(0) :
  null;

  return {
    references,
    excludeConnectionsTab: Boolean(state.relationships.list.connectionsGroups.length),
    connectionsGroups: state.relationships.list.connectionsGroups,
    relationships: ownProps.references,
    defaultLanguage,
    templates: state.templates,
    formData: state[ownProps.storeKey].sidepanel.metadata,
    formState: state[ownProps.storeKey].sidepanel.metadataForm,
    currentSidepanelView: state.library.sidepanel.view,
    selectedDocument,
    // relationships v2
    newRelationshipsEnabled: !!((_state$settings = state.settings) !== null && _state$settings !== void 0 && (_state$settings$colle = _state$settings.collection) !== null && _state$settings$colle !== void 0 && (_state$settings$colle2 = _state$settings$colle.get('features')) !== null && _state$settings$colle2 !== void 0 && _state$settings$colle2.get('newRelationships'))
  };
};

export { DocumentSidePanel, mapStateToProps };

export default connect(mapStateToProps)(withContext(withRouter(DocumentSidePanel)));